// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2B0hb","radioRow":"SimpleQuestionBuilderModal_radioRow__3fY6p"};